module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/af2202211ca1873edb949012dab6f9d1.svg";